(function () {
  const GRID_SELECTOR = "#product-grid";
  const LOADER_SELECTOR = ".pagination-load-more.auto-load";
  // Auto-fetch this many pages back-to-back, then require a tap to continue.
  // Unbounded auto-loading on a large collection (500+ products) keeps
  // appending product cards forever with nothing ever removed, which was
  // crashing iOS Safari/Chrome (WKWebView runs out of memory) on long
  // scroll sessions. This puts a hard ceiling on how much can pile up
  // between deliberate user actions.
  const AUTO_LOAD_LIMIT = 4;

  let observer = null;
  let isLoading = false;
  let autoLoadCount = 0;

  function initAutoLoad() {
    const loader = document.querySelector(LOADER_SELECTOR);
    if (!loader) return;

    autoLoadCount = 0;
    resumeAutoLoad(loader);
  }

  function watchLoader(loader) {
    if (observer) {
      observer.disconnect();
      observer = null;
    }

    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !isLoading) {
            loadNext(loader);
          }
        });
      },
      {
        rootMargin: "500px",
      },
    );

    observer.observe(loader);
  }

  function switchToManualLoad(loader) {
    if (observer) {
      observer.disconnect();
      observer = null;
    }

    const spinner = loader.querySelector(".auto-load-spinner");
    const manualBtn = loader.querySelector(".pagination-load-more__manual-btn");

    if (spinner) spinner.hidden = true;
    if (manualBtn) {
      manualBtn.hidden = false;
      manualBtn.addEventListener("click", onManualLoad);
    }
  }

  function resumeAutoLoad(loader) {
    const spinner = loader.querySelector(".auto-load-spinner");
    const manualBtn = loader.querySelector(".pagination-load-more__manual-btn");

    if (manualBtn) {
      manualBtn.hidden = true;
      manualBtn.removeEventListener("click", onManualLoad);
    }
    if (spinner) spinner.hidden = false;

    watchLoader(loader);
  }

  function onManualLoad(event) {
    event.preventDefault();
    if (isLoading) return;
    const loader = event.currentTarget.closest(LOADER_SELECTOR);
    if (!loader) return;
    event.currentTarget.removeEventListener("click", onManualLoad);
    autoLoadCount = 0;
    loadNext(loader);
  }

  function loadNext(loader) {
    const nextUrl = loader.dataset.nextUrl;
    if (!nextUrl) return;

    isLoading = true;

    let fetchUrl = nextUrl;

    if (loader.dataset.sectionId) {
      fetchUrl += fetchUrl.includes("?")
        ? "&section_id=" + loader.dataset.sectionId
        : "?section_id=" + loader.dataset.sectionId;
    }

    fetch(fetchUrl)
      .then((res) => res.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");

        const newGrid = doc.querySelector(GRID_SELECTOR);
        const currentGrid = document.querySelector(GRID_SELECTOR);

        if (!newGrid || !currentGrid) return;

        // Append new items
        newGrid.querySelectorAll("li.grid__item").forEach((item) => {
          currentGrid.appendChild(item.cloneNode(true));
        });

        isLoading = false;
        autoLoadCount++;

        // Find next loader in response
        const newLoader = doc.querySelector(LOADER_SELECTOR);

        if (newLoader && newLoader.dataset.nextUrl) {
          loader.dataset.nextUrl = newLoader.dataset.nextUrl;

          if (autoLoadCount >= AUTO_LOAD_LIMIT) {
            switchToManualLoad(loader);
          } else {
            resumeAutoLoad(loader);
          }
        } else {
          if (observer) {
            observer.disconnect();
            observer = null;
          }
          loader.remove();
        }

        reInitTheme();
      })
      .catch((err) => {
        console.error("Auto Load Error:", err);
        isLoading = false;
      });
  }

  function reInitTheme() {
    if (typeof BlsLazyloadImg !== "undefined" && BlsLazyloadImg.init) {
      BlsLazyloadImg.init();
    }

    if (typeof initializeScrollAnimationTrigger === "function") {
      initializeScrollAnimationTrigger();
    }

    if (typeof initAllCards === "function") {
      initAllCards();
    }

    // ✅ ADD THIS LINE
    initVisibleSwipers(document.querySelector("#product-grid"));

    if (typeof window.sortCollectionGridByStock === "function") {
      window.sortCollectionGridByStock();
    }
  }

  function init() {
    setTimeout(initAutoLoad, 200);
  }

  document.addEventListener("DOMContentLoaded", init);
  document.addEventListener("shopify:section:load", init);
  document.addEventListener("facet:rendered", init);
})();
